module.exports = __webpack_public_path__ + "img/inbox-gray.36fe101c.svg";